import {Alert, Center, Loader, Paper, Title} from '@mantine/core'

import {businessCalendarDate} from 'src/api/business-time'
import {useDispatchYards} from 'src/dispatch/use-dispatch'

import {ActiveRentalsTable} from './active-rentals-table'
import {activeRentalsCsvFilename} from './export-active-rentals-csv'
import {useActiveRentals} from './use-active-rentals'

export function ActiveRentalsBoardView({yardId}: {yardId: string | null}) {
    const {data: rows = [], isLoading, error} = useActiveRentals({mine: false, yardId})
    const {data: yards = []} = useDispatchYards()
    const yardName = yardId ? (yards.find((yard) => yard.id === yardId)?.name ?? 'yard') : 'all'

    return (
        <Paper withBorder p="md" radius="md" data-testid="active-rentals-board-view">
            <Title order={3} mb="sm">
                Active rentals
            </Title>
            {isLoading ? (
                <Center py="xl">
                    <Loader aria-label="Loading active rentals" />
                </Center>
            ) : error ? (
                <Alert color="red" title="Could not load active rentals">
                    {error.message}
                </Alert>
            ) : (
                <ActiveRentalsTable
                    rows={rows}
                    csvFilename={activeRentalsCsvFilename(yardName, businessCalendarDate())}
                />
            )}
        </Paper>
    )
}
